import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import store from '@/store.js'

import globals from '@/globals'

// Layouts
import LayoutCustomer from '@/layout/LayoutCustomer'
import Layout2 from '@/layout/Layout2'
import LayoutMap from '@/layout/LayoutMap'

// Eager load all application components so routes remain usable offline
import AdminLogin from '@/components/admin/Login'
import Suppliers from '@/components/Suppliers'
import AdminRegister from '@/components/admin/Register'
import AdminForgot from '@/components/admin/Forgot'
import AdminReset from '@/components/admin/Reset'
import AdminWizard from '@/components/admin/Wizard'
import AdminPrivacy from '@/components/admin/Privacy'
import AdminSupport from '@/components/admin/Support'
import AdminDashboard from '@/components/admin/Dashboard'
import AdminAccount from '@/components/admin/Account'
import AdminSettings from '@/components/admin/Settings'
import CompanyCustomers from '@/components/companies/Customers'
import Orders from '@/components/orders/Orders'
import Invoice from '@/components/invoice/Invoice'
import InvoiceCustomers from '@/components/invoice/Invoice-customers'
import OrderEdit from '@/components/orders/Order-edit'
import OrderEditOffline from '@/components/orders/Order-edit-offline'
import Worklog from '@/components/worklog/Worklog'
import Fls from '@/components/fls/Fls'
import Licecount from '@/components/licecount/Licecount'
import LicecountEdit from '@/components/licecount/Licecount-edit'
import Declarations from '@/components/declarations/Declarations'
import Planner from '@/components/planner/Planner'
import Vessels from '@/components/vessels/Vessels'
import Crew from '@/components/crew/Crew'
import Skift from '@/components/skift/Skift'
import Mannskapsplanlegger from '@/components/mannskapsplan/Mannskapsplanlegger'
import Rapportmaler from '@/components/rapporter/Rapportmaler'
import CrewOverview from '@/components/crew/Crew-overview'
import CustomerHome from '@/components/customer/Customer-home'
import CustomerAccount from '@/components/customer/Customer-account'
import CustomerSettings from '@/components/customer/Customer-settings'
import CustomerNewOrder from '@/components/customer/Customer-neworder'
import CustomerOrders from '@/components/customer/Customer-orders'
import CustomerViewOrder from '@/components/customer/Customer-vieworder'
import CustomerLicecount from '@/components/customer/Customer-licecount'
import CustomerLicecountEdit from '@/components/customer/Customer-licecount-edit'
import CustomerMap from '@/components/customer/Customer-map'
import ToolAquaregister from '@/components/tools/Aquaregister'
import ToolMap from '@/components/tools/Map'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  routes: [
    {
      path: "/",
      name: "home",
      requiresAuth: true,
      component: AdminLogin,
    },
    {
      path: "/suppliers",
      name: "suppliers",
      component: Suppliers,
    },
    {
      path: "/login",
      name: "login",
      component: AdminLogin,
    },
    {
      path: "/register",
      name: "register",
      meta: {
        requiresAuth: false
      },
      component: AdminRegister,
    },
    {
      path: '/password-forgot',
      name: "password-forgot",
      component: AdminForgot,
    },
    {
      path: '/password-reset',
      name: "password-reset",
      component: AdminReset,
    },
    {
      path: '/wizard',
      name: "wizard",
      component: AdminWizard,
    },
    {
      path: '/privacy',
      name: "privacy",
      requiresAuth: true,
      component: AdminPrivacy,
    },
    {
      path: '/support',
      name: "support",
      requiresAuth: true,
      component: AdminSupport,
    },
    {
      path: '/dashboard',
      component: Layout2,
      meta: {
        requiresAuth: true,
      },
      children: [
      {
        path: 'home',
        component: AdminDashboard,
      },
      {
        path: 'account',
        component: AdminAccount,
      },
      {
        path: 'settings',
        component: AdminSettings,
      },
      {
        path: 'customers',
        component: CompanyCustomers,
      },
      {
        path: 'orders',
        component: Orders,
      },
      {
        path: 'invoice',
        component: Invoice,
      },
      {
        path: 'invoice-customers',
        component: InvoiceCustomers,
      },
      {
        path: 'order-edit/:id',
        name: 'order-edit',
        props: true,
        component: OrderEdit,
      },
      {
        path: 'order-edit-offline/:id',
        name: 'order-edit-offline',
        props: true,
        component: OrderEditOffline,
      },
      {
        path: 'worklog',
        component: Worklog,
      },
      {
        path: 'fls',
        component: Fls,
      },
      {
        path: 'licecount',
        component: Licecount,
      },
      {
        path: 'licecount-edit/:id',
        name: 'licecount-edit',
        props: true,
        component: LicecountEdit,
      },
      {
        path: 'declarations',
        component: Declarations,
      },
      {
        path: 'planner',
        component: Planner,
      },
      {
        path: 'vessels',
        component: Vessels,
      },
      {
        path: 'crew',
        component: Crew,
      },
      {
        path: 'skift',
        component: Skift,
      },
      {
        path: 'mannskapsplan',
        component: Mannskapsplanlegger,
      },
      {
        path: 'rapportmaler',
        component: Rapportmaler,
      },
      {
        path: 'crew-overview',
        component: CrewOverview,
      },
    ],
  },
  {
    path: '/customer',
    component: LayoutCustomer,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'home',
        props: true,
        component: CustomerHome,
      },
      {
        path: 'account',
        component: CustomerAccount,
      },
      {
        path: 'settings',
        props: true,
        component: CustomerSettings,
      },
      {
        path: 'neworder',
        props: true,
        component: CustomerNewOrder,
      },
      {
        path: 'orders',
        props: true,
        component: CustomerOrders,
      },
      {
        path: 'order-view/:id',
        name: 'order-view',
        props: true,
        component: CustomerViewOrder,
      },
      {
        path: 'licecount-customer',
        props: true,
        component: CustomerLicecount,
      },
      {
        path: 'licecount-customer-edit/:id',
        name: 'licecount-customer-edit',
        props: true,
        component: CustomerLicecountEdit,
      },
      {
        path: 'map',
        props: true,
        component: CustomerMap,
      },
    ],
  },
  {
    path: '/tools',
    component: LayoutMap,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'site',
        component: ToolAquaregister,
      },
      {
        path: 'map',
        component: ToolMap,
      },
    ],
  },
],
})

router.afterEach(() => {
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Allow a link to carry its own sign-in (e.g. a public display screen),
  // then strip the credentials from the URL before continuing.
  if (to.query.token) {
    store.dispatch('ssoLogin', { token: to.query.token, company: to.query.company })

    const { token, company, ...query } = to.query
    next({ path: to.path, query, replace: true })
    return
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      // Add tiny timeout to finish page transition
      setTimeout(() => next(), 10)
      return
    }
    next('/login')
  } else {
    // Add tiny timeout to finish page transition
    setTimeout(() => next(), 10)
  }
})

// Handle chunk loading errors (e.g., when offline and trying to load lazy-loaded routes)
router.onError((error) => {
  if (/Loading chunk .* failed/.test(error.message)) {
    console.warn('Chunk loading failed, possibly offline:', error.message)
    // You could optionally redirect to a cached page or show an error
    // For now, just log it to avoid breaking the app
  }
})

export default router
